import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=031643b4&scoped=true"
import script from "./Changelog.vue?vue&type=script&lang=ts"
export * from "./Changelog.vue?vue&type=script&lang=ts"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=031643b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031643b4",
  null
  
)

export default component.exports